import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';
import affirmationProgramEnumerators from 'src/modules/affirmationProgram/affirmationProgramEnumerators';

export default [
  {
    name: 'title',
    label: i18n('entities.affirmationProgram.fields.title'),
    schema: schemas.string(
      i18n('entities.affirmationProgram.fields.title'),
      {
        required: true,
        min: 1,
      },
    ),
  },
  {
    name: 'type',
    label: i18n('entities.affirmationProgram.fields.type'),
    schema: schemas.enumerator(
      i18n('entities.affirmationProgram.fields.type'),
      {
        required: true,
        options: affirmationProgramEnumerators.type,
      },
    ),
  },
  {
    name: 'orderInList',
    label: i18n(
      'entities.affirmationProgram.fields.orderInList',
    ),
    schema: schemas.integer(
      i18n(
        'entities.affirmationProgram.fields.orderInList',
      ),
      {},
    ),
  },
  {
    name: 'includedInTier',
    label: i18n(
      'entities.affirmationProgram.fields.includedInTier',
    ),
    schema: schemas.relationToMany(
      i18n(
        'entities.affirmationProgram.fields.includedInTier',
      ),
      {
        required: true,
        min: 1,
      },
    ),
  },
  {
    name: 'sendToAllUsersInTier',
    label: i18n(
      'entities.affirmationProgram.fields.sendToAllUsersInTier',
    ),
    schema: schemas.boolean(
      i18n(
        'entities.affirmationProgram.fields.sendToAllUsersInTier',
      ),
    ),
  },
  {
    name: 'slug',
    label: i18n('entities.affirmationProgram.fields.slug'),
    schema: schemas
      .string(
        i18n('entities.affirmationProgram.fields.slug'),
        {
          required: true,
        },
      )
      .matches(
        /^[a-z0-9][-a-zA-Z0-9]*$/,
        i18n('entities.affirmationProgram.validation.slug'),
      ),
  },
  {
    name: 'summary',
    label: i18n(
      'entities.affirmationProgram.fields.summary',
    ),
    schema: schemas.string(
      i18n('entities.affirmationProgram.fields.summary'),
      {
        max: 160,
      },
    ),
  },
  {
    name: 'description',
    label: i18n(
      'entities.affirmationProgram.fields.description',
    ),
    schema: schemas.string(
      i18n(
        'entities.affirmationProgram.fields.description',
      ),
      {},
    ),
  },
  {
    name: 'smsTemplate',
    label: i18n(
      'entities.affirmationProgram.fields.smsTemplate',
    ),
    schema: schemas.string(
      i18n(
        'entities.affirmationProgram.fields.smsTemplate',
      ),
    ),
  },
  {
    name: 'wrapUpSms',
    label: i18n(
      'entities.affirmationProgram.fields.wrapUpSms',
    ),
    schema: schemas.string(
      i18n('entities.affirmationProgram.fields.wrapUpSms'),
    ),
  },
  {
    name: 'welcomeSms',
    label: i18n(
      'entities.affirmationProgram.fields.welcomeSms',
    ),
    schema: schemas.string(
      i18n('entities.affirmationProgram.fields.welcomeSms'),
    ),
  },
  {
    name: 'notificationTemplate',
    label: i18n(
      'entities.affirmationProgram.fields.notificationTemplate',
    ),
    schema: schemas.string(
      i18n(
        'entities.affirmationProgram.fields.notificationTemplate',
      ),
    ),
  },
  {
    name: 'wrapUpNotification',
    label: i18n(
      'entities.affirmationProgram.fields.wrapUpNotification',
    ),
    schema: schemas.string(
      i18n(
        'entities.affirmationProgram.fields.wrapUpNotification',
      ),
    ),
  },
  {
    name: 'welcomeNotification',
    label: i18n(
      'entities.affirmationProgram.fields.welcomeNotification',
    ),
    schema: schemas.string(
      i18n(
        'entities.affirmationProgram.fields.welcomeNotification',
      ),
    ),
  },
  {
    name: 'hidden',
    label: i18n(
      'entities.affirmationProgram.fields.hidden',
    ),
    schema: schemas.boolean(
      i18n('entities.affirmationProgram.fields.hidden'),
      {},
    ),
  },
  {
    name: 'AffirmationProgramSquareArt',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramSquareArt',
    ),
    schema: schemas.files(
      i18n('entities.affirmationProgram.fields.AffirmationProgramSquareArt'),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'AffirmationProgramSquareArtHD',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramSquareArtHD',
    ),
    schema: schemas.files(
      i18n(
        'entities.affirmationProgram.fields.AffirmationProgramSquareArtHD',
      ),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'AffirmationProgramLandscapeArt',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramLandscapeArt',
    ),
    schema: schemas.files(
      i18n(
        'entities.affirmationProgram.fields.AffirmationProgramLandscapeArt',
      ),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'AffirmationProgramLandscapeArtHD',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramLandscapeArtHD',
    ),
    schema: schemas.files(
      i18n(
        'entities.affirmationProgram.fields.AffirmationProgramLandscapeArtHD',
      ),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'AffirmationProgramPortraitArt',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramPortraitArt',
    ),
    schema: schemas.files(
      i18n(
        'entities.affirmationProgram.fields.AffirmationProgramPortraitArt',
      ),
      {
        max: 1,
      },
    ),
  },
  {
    name: 'AffirmationProgramPortraitArtHD',
    label: i18n(
      'entities.affirmationProgram.fields.AffirmationProgramPortraitArtHD',
    ),
    schema: schemas.files(
      i18n(
        'entities.affirmationProgram.fields.AffirmationProgramPortraitArtHD',
      ),
      {
        max: 1,
      },
    ),
  },
];
